import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Amplify } from 'aws-amplify';
import 'bootstrap/dist/css/bootstrap.min.css';
import awsExports from './aws-exports'; // Ensure aws-exports.js is correctly referenced

Amplify.configure({
	...awsExports, // Spread the existing exports
	Storage: {
		AWSS3: {
			bucket: 'portfolio-projects-2024',
			region: 'us-west-1',
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
